import type {PropsWithChildren} from "react";

export interface DrawerProps extends PropsWithChildren{
  isOpen: boolean;
  className?: string;
  onClose: VoidFunction;
  overlay?: boolean;
  direction?: Direction;
}

export enum Direction {
  LEFT = 'left',
  RIGHT = 'right',
}